<script lang="ts">
  import Media from '../Media/Media.svelte';
</script>

<article>
  <section class="section-title" id="service">
    <h2>サービスについて</h2>
  </section>

  <section class="service-sptr content-inner">
    <h3 class="topic-title">SPTR</h3>
    <div>
      <p>
        スパトレは、第二言語習得・認知心理学・脳科学の研究結果を活用し確実に英語力を身に付けることを目的とした英語トレーニングサービスです。
      </p>
      <p>
        <a href="https://sptr.jp/" class="link-blank">
          SPTRサイトへ
        </a>
      </p>
    </div>
    <div class="service-sptr-item mt-40">
      <div>
        <img src="img/sptr_point1.jpg" alt="" />
        <h4>実力に合わせた最適な学習方法を提案</h4>
      </div>
      <div>
        <img src="img/sptr_point2.jpg" alt="" />
        <h4>第二言語習得論に基づく学習体系</h4>
      </div>
      <div>
        <img src="img/sptr_point3.jpg" alt="" />
        <h4>プロのトレーナーがあなたを最大限サポート</h4>
      </div>
      <div>
        <img src="img/sptr_point4.jpg" alt="" />
        <h4>成果を最短で得るための徹底した予習・復習</h4>
      </div>
    </div>
  </section>

  <section class="service-foruser content-inner">
    <h3 class="topic-title">一般のお客様向け</h3>
    <p>
      月額5,980円から始める英語トレーニング。大量のインプットと少量のアウトプットを学習の基本として英会話レッスンだけでなく徹底した自習を重視、日本人サポートや外国人トレーナーによる継続的なサポートにより成果にこだわる英語トレーニングを提供します。
      <br />
      <a href="https://sptr.jp/" class="link-blank">
        SPTRサイト
      </a>
    </p>
  </section>

  <section class="service-company content-inner">
    <h3 class="topic-title">企業向け</h3>
    <p>
      ビジネスから日常会話まで、目的に応じた研修をアレンジしご提案いたします。評価等のタイミングに応じたレポート等のご共有も可能です。これまで大手企業様や外務省等の省庁様からご利用いただき、高い成果を上げております。
    </p>
  </section>

  <section class="service-school content-inner">
    <h3 class="topic-title">教育機関向け</h3>
    <p>
      スパトレのサービスを教育機関向けに最適化。学校向けサービスでは初回テストに基づき、生徒様の学年・レベル・目標にあわせてひとりひとりに合わせた学習方法と教材を提案しております。
      <br />
      <a href="https://school.sptr.jp/" class="link-blank">
        教育機関向けサイト
      </a>
    </p>
    <ul class="school-introduction">
      <li>
        <img src="img/sptr-school01.png" alt="" />
        北海道 鹿追中学校
      </li>
      <li>
        <img src="img/sptr-school02.png" alt="" />
        北海道 瓜幕中学校
      </li>
      <li>
        <img src="img/sptr-school03.png" alt="" />
        千葉県 幕張本郷中学校
      </li>
      <li>
        <img src="img/sptr-school04.png" alt="" />
        愛知県 滝高等学校
      </li>
    </ul>
  </section>

  <section class="service-sptr content-inner">
    <h3 class="topic-title">atomico</h3>
    <div>
      <p>
        atomicoはただ英語に触れる場所ではありません。興味のあることを英語で学び、自ら探究することができる学童です。
      </p>
      <p>
        <a href="https://www.atomico.co.jp/" class="link-blank">
          atomicoサイトへ
        </a>
      </p>
    </div>
    <div class="service-sptr-item mt-40 is-atomico">
      <div>
        <img src="img/features1.webp" alt="" />
        <h4>科学的理論に基づく効果的な学習メソッド</h4>
      </div>
      <div>
        <img src="img/features2.webp" alt="" />
        <h4>1日4つの個性別オンライン英語トレーニング</h4>
      </div>
      <div>
        <img src="img/features3.webp" alt="" />
        <h4>興味のあることを「英語で探究するプログラム」</h4>
      </div>
    </div>
  </section>

  <Media />
</article>

<style>
  .service-sptr,
  .service-foruser,
  .service-company,
  .service-school {
    padding: 40px;
    padding-left: 12%;
    display: grid;
    grid-template-columns: 50% 1fr;
  }

  .service-sptr {
    padding-left: 40px;
  }

  .service-sptr-item {
    grid-column: 1 / 3;
    display: flex;
    justify-content: space-between;
  }

  .service-sptr-item div {
    width: 200px;
  }

  .service-sptr-item div img {
    display: block;
    width: 200px;
    height: 140px;
    object-fit: cover;
  }

  .service-sptr-item div h4 {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.4;
    text-align: justify;
    color: #7521da;
  }

  .service-sptr-item.is-atomico img {
    width: auto;
    height: 150px;
  }

  .school-introduction {
    grid-column: 1 / 3;
    display: flex;
    justify-content: space-between;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .school-introduction li {
    margin: 0;
    padding: 0;
    width: 200px;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.4;
    text-align: justify;
    color: #000000;
  }

  .school-introduction img {
    display: block;
    width: 200px;
    height: 140px;
    object-fit: cover;
  }

  .section-title {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    text-align: center;
    border-top: 1px solid #D0DBF7;
    border-bottom: 1px solid #D0DBF7;
    background-color: #F8F9FD;
    position: relative;
    left: 50%;
    right: 50%;
    transform: translateX(-50%);
  }

  .section-title h2 {
    width: 1000px;
    margin: 0 auto;
    height: 185px;
    display: inline-flex;
    align-items: center;
    padding: 0;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 43px;
    letter-spacing: 0.1em;
    color: #7521da;
  }

  .topic-title {
    margin: 0;
    padding: 0;
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: bold;
    font-size: 2.5rem;
    line-height: 36px;
    letter-spacing: 0.1em;
    color: #7521da;
  }

  .link-blank {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    color: #7521da;
    background-image: url(/img/icon-outlink.svg);
    background-repeat: no-repeat;
    padding-left: 20px;
    background-position: center left;
  }

  @media screen and (max-width: 768px) {
    .service-sptr,
    .service-foruser,
    .service-company,
    .service-school {
      display: flex;
      flex-direction: column;
      padding: 20px 10px;
    }

    .service-sptr {
      padding-left: inherit;
    }


    .service-sptr-item {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .service-sptr-item div {
      width: 48%;
    }

    .service-sptr-item div img {
      width: 100%;
    }

    .service-sptr-item div h4 {
      font-size: 1.4rem;
    }

    .school-introduction {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .school-introduction li {
      width: 48%;
      margin-bottom: 10px;
      font-size: 1.3rem;
    }

    .school-introduction img {
      width: 100%;
      height: 120px;
    }

    .section-title h2 {
      width: 90%;
      height: 79px;
      font-size: 2rem;
    }

    .topic-title {
      font-size: 1.8rem;
    }
  }
</style>
